module.exports = __webpack_public_path__ + "img/arrow.aaf00719.svg";